<template>
  <svg
    viewBox="-18 -283 1920 61"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m1902-270.18c-72.35-23.65-160.49-14.59-264.4 27.18-155.87 62.65-315.53-44.07-525.54-8.45s-248.08 35.63-450.96-11.64-331.1 47.42-463.56 11.65c-88.31-23.85-160.16-21.03-215.54 8.44v21h1920z"
    />
  </svg>
</template>
